import React from 'react';
import { Translation } from 'react-i18next';
import { Breadcrumb, Typography, Button, Col, Row } from 'antd';
import { arrowLeft } from '../../../elements/components/Icons';
import { withRouter } from 'react-router-dom';
import Logger from '../../../../../lib/Logger';
import { pathTo } from '../../../Routes';

const { Title } = Typography;

const LearningModuleStepViewHeader = ({
  activeId,
  moduleId,
  title,
  order,
  ...props
}) => {
  const goBack = () => {
    props.history.push(
      pathTo('LearningModuleStepsScreen', { id: activeId, moduleId })
    );
  };

  return (
    <Translation>
      {(t) => (
        <>
          <div className='learning-module-learning-step-view-header'>
            <Button
              className='icon-button'
              type='text'
              icon={arrowLeft(10, 17)}
              onClick={goBack}
            />
            <Breadcrumb>
              <Breadcrumb.Item>
                {t('learning_breadcrumb_learning')}
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {t('learning_breadcrumb_module_series')}
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {t('learning_breadcrumb_modules')}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Row>
            <Col>
              <div className='ant-steps-item ant-steps-item-active ant-steps-item-process'>
                <div className='ant-steps-item-container'>
                  <div className='ant-steps-item-icon'>
                    <span className='ant-steps-icon'>{order}</span>
                  </div>
                </div>
              </div>
            </Col>

            <Col>
              <Title
                level={3}
                className='learning-module-learning-step-view-title'
              >
                {title}
              </Title>
            </Col>
          </Row>
        </>
      )}
    </Translation>
  );
};

export default withRouter(LearningModuleStepViewHeader);

Logger.log('silly', `LearningModuleStepViewHeader loaded.`);
